import React, { useContext } from "react";

import { Stack } from "@mui/material";

import { MeetingInfoContext } from "../../../../context";

import LeaveCallButton from "./buttons/leave-call-button";
import CameraButton from "./buttons/camera-button";
import UploadImageButton from "./buttons/upload-image-button";

const HeadsetControlBar: React.FC = () => {
  const { errorMessage } = useContext(MeetingInfoContext);
  const disabled = errorMessage != null;

  return (
    <Stack
      spacing={2}
      direction={"row"}
      justifyContent={"stretch"}
      alignItems={"stretch"}
      width={"100%"}
      px={1}
      boxSizing={"border-box"}
    >
      {!disabled && (
        <>
          <Stack flex={1}>
            <CameraButton startWithVideo={true} />
          </Stack>
          <Stack flex={1}>
            <UploadImageButton />
          </Stack>
          <Stack flex={1}>
            <LeaveCallButton />
          </Stack>
        </>
      )}
    </Stack>
  );
};

export default HeadsetControlBar;
